export const updateDocumentsState = (dmsDocumentType, documentChanges) => documents =>
    documents.map(document =>
        document.dmsDocumentType === dmsDocumentType
            ? {
                  ...document,
                  ...documentChanges,
              }
            : document
    );
